import { ApiUtility } from "./ApiUtility";
import { v4 as uuidv4 } from 'uuid';

const deviceid = uuidv4();

class LoginServices {
  login = "/api/user/login";
  getOtp = "/api/user/sendotp?mobileno=";
  validateOtp = "/api/user/validateotp?key=";
  refreshtkn = "/api/user/RefreshToken?userId="

  getUserLogin = (
    countryCode: string,
    phoneNumber: string,
    emailId: string,
    signInMode?: string,
    name?: string,
    imagePath?: string,
    fcm_token?: string,
    facebook_Id?: string,
  ) => {
    return ApiUtility.post(this.login, {
      countryCode,
      phoneNumber,
      emailId,
      signInMode,
      medium: 1,
      language: localStorage.getItem("lan"),
      fcm_token,
      name,
      imagePath,
      facebook_Id,
      bookView: "",
      device_Id: deviceid
    });
  };


  sendOtp = (
    mobileno: string,
    oldKey: string
  ) => {
    return ApiUtility.get(this.getOtp + mobileno + "&oldKey=" + oldKey)
  }

  validOtp = (key: string, value: string) => {
    return ApiUtility.post(this.validateOtp + key + "&value=" + value, {})
  }

  refreshToken = () => {
    return ApiUtility.post(this.refreshtkn + localStorage?.getItem("UserId") + "&medium=1&fcm_token=" + localStorage?.getItem("Token"), {})
  }

  refreshTokenV2 = (userId: string, fcmToken: string = "") => {
    return ApiUtility.post("/api/user/RefreshTokenV2", {
      userId: userId,
      medium: 1,
      fcmToken: fcmToken
    });
  }
}
export default new LoginServices();
